import './TableVendor.scss';

const TopVendorsCard = ({ title, data = [] }) => {
  return (
    <div className="top-vendors-card">
      <div className="card-header">
        <h3>{title}</h3>
      </div>
      <div className="card-body">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th className="align-right">Total Expenses</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index} className={index % 2 === 1 ? 'alt-row' : ''}>
                <td>{item.Name}</td>
                <td className="align-right">
                  ${item.expenses.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TopVendorsCard;
